const directives = {
    install(Vue) {
        Vue.directive('capitalize', {
            bind: function (el, _, vnode) {
                el.addEventListener('input', (e) => {
                    let name = e.target.value
                    const capitalizedFirst = name[0].toUpperCase();
                    const rest = name.slice(1);
                    e.target.value = capitalizedFirst + rest
                    vnode.componentInstance.$emit('input', e.target.value)
                })
            }
        });
        Vue.directive('uppercase', {
            bind: function (el, _, vnode) {
                el.addEventListener('input', (e) => {
                    e.target.value = e.target.value.toUpperCase()
                    vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
                })
            }
        })
    }
}
    
export default directives